import { financesComponent } from './finances.component';

export const financesStateName = 'app.ticket.finances';

export const financesState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: financesStateName,
    url: '/finances?upload?edit',
    params: {
      upload: null
    },
    component: financesComponent.name,
    data: { requiresAuth: true }
  });
};
